<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.kosul"  url="QuestionConditions" :show_button="true"  icon="arrow-left" buttontype="danger" label="Geri"></ContentHeader>


<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
    

<!-- text-->
<template v-if="$store.state.questions.question.type=='text'">
<h4 class="text-primary">{{$store.state.languages.lang_phrases.text_turu_sorular_icin_kosul_secenegi_bulunmuyor}}</h4>
	
</template>
<!-- text-->

<!-- longtext-->
<template v-if="$store.state.questions.question.type=='longtext'">
<h4 class="text-primary">{{$store.state.languages.lang_phrases.uzun_text_turu_sorular_icin_kosul_secenegi_bulunmuyor}}</h4>
</template>
<!-- longtext-->






<!-- number-->
<template v-if="$store.state.questions.question.type=='number'">
<h4 class="text-primary">Sayı türü soru için koşullar</h4>
<span>Girilen değer</span>
<!-- enter digit-->
<InputNumber v-model="item.entered_number_val" mode="decimal" :minFractionDigits="0" :maxFractionDigits="10" @input="numberTypeEntered" class="p-inputtext-sm ml-2"/>
<!-- enter digit-->

<!-- select condition-->
<Dropdown :filter="true" v-if="number_val_entered" v-model="item.selected_number_val_option" :options="number_val_options" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="selectedNumberValEntered"/>
<!-- select condition-->
<span class="ml-2" v-if="number_val_entered">,</span>

</template>
<!-- number-->




<!-- select-->
<template v-if="$store.state.questions.question.type=='select'">
<h4 class="text-primary">Seçim türü soru için koşullar</h4>
<span>Seçilen değer</span>
<Dropdown :filter="true"  v-model="item.selected_inputfield_option" :options="inputfield_options" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" @change="selectedNumberValEntered"/>
<span class="ml-2" v-if="condition_entered"> ise </span>
</template>
<!-- select-->




<!-- multiselect-->
<template v-if="$store.state.questions.question.type=='multiselect'">
	
</template>
<!-- multiselect-->

<!-- columns-->
<template v-if="$store.state.questions.question.type=='columns'">
	
</template>
<!-- columns-->

<!-- boolean-->
<template v-if="$store.state.questions.question.type=='boolean'">
    
</template>
<!-- boolean-->













<!-- select affected item type-->

<Dropdown :filter="true" v-if="condition_entered" v-model="item.affected_item_type" :options="effected_items" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="getAffectedItems" />
<!-- select affected item type-->









<!-- selected affected item type-->
<template v-if="item.affected_item_type">









<!-- section-->
<template v-if="item.affected_item_type=='section'">
    <Dropdown :filter="true"  v-model="item.selected_section" :options="sections" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" :loading="loading_sections"  @change="sectionSelected"/>

    <span class="ml-2" v-if="section_selected"> puanını</span>
    <!-- if selected is points-->
    <InputNumber  v-if="section_selected" v-model="item.selected_item_altered_points" mode="decimal" :minFractionDigits="0" :maxFractionDigits="10" :max="100" class="p-inputtext-sm ml-2" />
    <Dropdown :filter="true"  v-if="section_selected" v-model="item.selected_inputfield_points_option" :options="selected_item_points_options" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" />
    <!-- if selected is points-->
</template>
<!-- section-->

















<!-- inputfield-->
<template v-if="item.affected_item_type=='inputfield'">

    <!-- the inputfield-->
    <Dropdown :filter="true"  v-model="item.selected_inputfield" :options="inputfields" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" :loading="loading_inputfields" @change="inputFieldSelected" />
    <!-- the inputfield-->

    <!-- the inputfield switch-->
    <Dropdown :filter="true"  v-if="input_field_selected" v-model="item.selected_inputfield_switch" :options="inputfield_switches" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm"  @change="inputfieldKeySelected" />
    <!-- the inputfield switch-->


    <!-- if selected is boolean-->
    <span class="ml-2" v-if="input_field_key_selected"> özelliğini</span>


    <Dropdown :filter="true"  v-if="input_field_key_selected" v-model="item.selected_inputfield_switch_state" :options="selected_inputfield_switch_states" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" @change="inputFieldKeyStateSelected"  />

    <span class="ml-2"  v-if="input_field_key_selected"> olarak değiştir</span>
    <!-- if selected is boolean-->




    <!-- if selected is points-->
    <InputNumber  v-if="input_field_points_option_selected" v-model="item.selected_item_altered_points" mode="decimal" :minFractionDigits="0" :maxFractionDigits="10" :max="100" class="p-inputtext-sm ml-2" />
    <Dropdown :filter="true"  v-if="input_field_points_option_selected" v-model="item.selected_inputfield_points_option" :options="selected_item_points_options" optionLabel="name" optionValue="code" class="ml-2 p-inputtext-sm" />
    <!-- if selected is points-->

    
</template>
<!-- inputfield-->











<!-- custom_attribute-->
<template v-if="item.affected_item_type=='custom_attribute'">
    <Dropdown :filter="true"  v-model="item.selected_custom_attribute" :options="custom_attributes" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" :loading="loading_custom_attributes" @change="customAttributeSelected"/>

    <template v-if="custom_attribute_selected">
        <span> özelliğini</span>
        <InputNumber  v-if="selected_custom_attribute_object.type=='number'" v-model="item.selected_customattribute_number_val" mode="decimal" :minFractionDigits="0" :maxFractionDigits="10" :max="100" class="p-inputtext-sm ml-2" />
        <InputText  v-if="selected_custom_attribute_object.type=='string'" v-model="item.selected_customattribute_text_val" class="p-inputtext-sm ml-2" />
        <Dropdown :filter="true"   v-if="selected_custom_attribute_object.type=='select'" v-model="item.selected_customattribute_option_val" :options="selected_custom_attribute_object.options" optionLabel="name" optionValue="id" class="ml-2 p-inputtext-sm" />

        <span> olarak değiştir</span>


    </template>
</template>
<!-- custom_attribute-->






</template>
<!-- selected affected item type-->




<div class="flex align-items-center justify-content-end mb-6 mt-4">

<Button label="Kaydet"  class="p-button-outlined p-button-sm p-button-primary" :loading="$store.state.ui.submitting" type="submit" @click="submit"></Button>
</div>

</template>


</div>
</template>

<script>
export default {

  name: 'QuestionCondition',

  data () {
    return {
        loading:true,
        item:{
            entered_number_val:null,
            selected_number_val_option:null,
            affected_item_type:null,
            selected_section:null,
            selected_inputfield:null,
            selected_custom_attribute:null,
            selected_inputfield_switch:null,
            selected_item_altered_points:null, 
            selected_inputfield_switch_state:null, 
            selected_inputfield_option:null,
            selected_customattribute_text_val:null,
            selected_customattribute_number_val:null,
            selected_customattribute_option_val:null,            
            selected_inputfield_points_option:null,
        },
    	
        number_val_entered:false,
        condition_entered:false,
        input_field_selected:false,
        input_field_key_selected:false,
        input_field_points_option_selected:false,        
        section_selected:false, 
        custom_attribute_selected:false,       
        sections:[],
        inputfields:[],
        custom_attributes:[],
        loading_sections:true,
        loading_inputfields:true,
        loading_custom_attributes:true,        
        number_val_options: [
            {name: 'den küçükse', code: 'lowerthan'},
            {name: 'den büyükse', code: 'higherthan'},
            {name: 'ise', code: 'equalto'},
        ],
        effected_items:[
            {name: 'Bölüm', code: 'section'},
            {name: 'Soru', code: 'inputfield'},            
            {name: 'Özel Nitelik', code: 'custom_attribute'},
        ],
        inputfield_switches:[
            {name: 'Görünür', code: 'show_field'},
            {name: 'Gerekli', code: 'is_required'}, 
            {name: 'Boş Geçilebilir', code: 'is_nullable'},           
            {name: 'Puanı', code: 'points'},
        ],       
        selected_inputfield_switch_states:[
            {name: 'Açık', code: 1},
            {name: 'Kapalı', code: 0},
        ],
        selected_item_points_options:[
            {name: 'olarak ayarla', code: "fixnumber"},
            {name: 'ekleyerek güncelle', code: "addnumber"},
            {name: 'çıkararak güncelle', code: "substractnumber"},
            {name: 'ile çarparak güncelle', code: "multiplynumber"},
            {name: 'ile bölerek güncelle', code: "dividenumber"},
        ],
        inputfield_options:[],
        inputfield_columns:[],
        selected_custom_attribute_object:null,

    }
  },
  async mounted()
  {
    //console.log(this.$store.state.questions.question)
    if(this.$store.state.questions.question.type=='select' || this.$store.state.questions.question.type=='multiselect')
    {
        this.inputfield_options = await this.generalApiGetWithoutLoader("questionlists/inputfield/options/"+this.$store.state.questions.question.id) 
    }
    if(this.$store.state.questions.question.type=='columns' )
    {
        this.inputfield_columns = await this.generalApiGetWithoutLoader("questionlists/inputfield/options/"+this.$store.state.questions.question.id) 
    }
    if(this.$route.params.condition_id)
    {
        this.getData()
    }
    else
    {
        this.loading = await false
    }



  },
  methods:{
    async getData()
    {
        this.loading = await true
        this.item = await this.generalApiGetWithoutLoader("questionlists/inputfield_condition/"+this.$route.params.condition_id)
        console.log(this.item)
        await this.getAffectedItems()
        this.condition_entered = await true
        if(this.item.affected_item_type=="inputfield")
        {
            this.loading_inputfields = await false
            
            this.input_field_selected = await true
            
            if(this.item.selected_inputfield_switch=="points")
            {
                this.input_field_points_option_selected = await true
            }
            else
            {
                this.input_field_key_selected = await true
            }            
        }
        if(this.item.affected_item_type=="section"){
            
            this.section_selected = await true
        }

        if(this.item.affected_item_type=="custom_attribute"){
            
            this.selected_custom_attribute_object = await this.item.affectedcustomattribute
            this.custom_attribute_selected = await true
        }
        


        this.loading = await false
    }, 

    submit()
    {
        let formdata = new FormData()
        formdata.append('questionlist_id', this.$store.state.questions.question.questionlist_id);
        formdata.append('inputfield_id', this.$store.state.questions.question.id);
        formdata.append('item', JSON.stringify(this.item));
        if(this.$route.params.condition_id)
        {
            this.generalSubmission(formdata,"questionlists/inputfield_condition/"+this.$route.params.condition_id,this.afterSubmit)
        }
        else
        {
            this.generalSubmission(formdata,"questionlists/inputfield_condition/store",this.afterSubmit)
        }
        
    },
    afterSubmit(response)
    {
        console.log(response.data);
        this.$router.push({ name: 'QuestionConditions' })  
    },
    customAttributeSelected()
    {
        console.log(this.item.selected_custom_attribute);
        this.selected_custom_attribute_object = this.sanitizeArray(this.custom_attributes).find((item)=>{return item.id == this.item.selected_custom_attribute})
        console.log(this.selected_custom_attribute_object);
        this.custom_attribute_selected = true
    },
  	numberTypeEntered(data)
  	{
  		this.item.entered_number_val = data.value
        if(data.value)
        {
            this.number_val_entered = true
        }
        else
        {
            this.number_val_entered = false
        }
  	},
    selectedNumberValEntered(data)
    {
        this.condition_entered = true
    },
  	getAffectedItems()
  	{
  		this.sections = []
  		this.inputfields = []
  		this.custom_attributes = []
  		if(this.item.affected_item_type=="section")
  		{
  			this.getSections()
  		}
  		if(this.item.affected_item_type=="inputfield")
  		{
  			this.getInputfields()
  		}

  		if(this.item.affected_item_type=="custom_attribute")
  		{
  			this.getCustomAttributes()
  		}

  	},
  	async getSections()
  	{
  		this.loading_sections = await true
  		let sections = await this.generalApiGetWithoutLoader("questionlists/inputfieldsections/"+this.$store.state.questions.question.questionlist_id)
        for(let section of sections)
        {
            
            if(section.name.length>30)
            {
                section.name = section.name.substring(0, 30)+"...";
            }
        }
        this.sections = await sections 
  		console.log(this.sections)
  		this.loading_sections = await false
  	},
  	async getInputfields()
  	{
  		this.loading_inputfields = await true
  		let inputfields = await this.generalApiGetWithoutLoader("questionlists/inputfields/"+this.$store.state.questions.question.questionlist_id) 
        for(let inputfield of inputfields)
        {
            if(inputfield.name.length>30)
            {
                inputfield.name = inputfield.name.substring(0, 30)+"...";
            }
            
        }
        this.inputfields = await inputfields
  		console.log(this.inputfields)
  		this.loading_inputfields = await false
  	},

  	async getCustomAttributes()
  	{
  		this.loading_custom_attributes = await true
  		this.custom_attributes = await this.generalApiGetWithoutLoader("custom_attributes/brand_attributes/"+this.$store.state.questionlists.question.brand_id) 
  		console.log(this.custom_attributes)
  		this.loading_custom_attributes = await false
  	},
    inputFieldSelected()
    {
        this.input_field_selected = true
    },
    inputFieldKeyStateSelected()
    {
        //this.input_field_key_selected = true

    },
    sectionSelected()
    {
        this.section_selected = true
    },
  	inputfieldKeySelected()
  	{
        let inputfields = this.sanitizeArray(this.inputfields)
        let inputfield = inputfields.find((element)=>{return element.id ==this.item.selected_inputfield})
        if(this.item.selected_inputfield_switch=="is_required" || this.item.selected_inputfield_switch=="show_field" || this.item.selected_inputfield_switch=="is_nullable")
        {

            //this.selected_inputfield_switch = inputfield[this.selected_inputfield_switch]
            this.input_field_key_selected = true
            this.input_field_points_option_selected = false

        }
         if(this.item.selected_inputfield_switch=="points" )
         {
            this.item.selected_item_altered_points = inputfield.points
            this.input_field_key_selected = false
            this.input_field_points_option_selected = true
         }
  		
        
  		

  	}
  }
};
</script>

<style lang="css" scoped>
</style>